export const colours = {
    WHITE: '#ffffff',
    GREY: '#DFE5EE',
    BLUE: '#375E92'
}